import React, { useEffect } from "react";
import { useIntl } from "react-intl";
import { useParams } from "react-router-dom";
import { getPublishedPageUrl } from "../component/website/websitePageUrls";

/** Legacy React route — redirects to backend HTML so title/favicon/OG come from the page itself. */
export function PublicWebsitePage() {
  const intl = useIntl();
  const { company, slug } = useParams<{ company: string; slug: string }>();

  useEffect(() => {
    if (!company || !slug) return;
    try {
      const companyId = atob(company);
      window.location.replace(getPublishedPageUrl(companyId, slug));
    } catch {
      window.location.replace("/");
    }
  }, [company, slug]);

  return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
      <div
        className="spinner-border text-primary"
        role="status"
        aria-label={intl.formatMessage({ id: "app.websitePage.preview.loading" })}
      />
    </div>
  );
}
